class CartProductRecommendations extends ProductRecommendations {
    constructor() {
        super();
        this.sectionId = document.querySelectorAll('[data-section-id]')[0].getAttribute('data-section-id');
        this.url = this.dataset.url + this.sectionId + this.dataset.url2;
      }

      configureMiniCartSwiper(recommendations) {
          const swiperSlider = recommendations.querySelector('swiper-slider');
          if (!swiperSlider) return;

          const swiperConfig = swiperSlider.getAttribute('data-swiper');
          if (!swiperConfig) return;

          const options = JSON.parse(swiperConfig);
          options.slidesPerView = 'auto';
          options.slidesPerGroup = 1;
          options.spaceBetween = 15;
          options.allowTouchMove = true;
          options.breakpoints = {
            1000: {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
              spaceBetween: 15,
              allowTouchMove: true,
            },
          };

          swiperSlider.setAttribute('data-swiper', JSON.stringify(options));
      }
    
      connectedCallback() {
          fetch(this.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
    
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.configureMiniCartSwiper(recommendations);
                this.innerHTML = recommendations.innerHTML;
              }
    
              if (!this.querySelector('slideshow-component') && !this.querySelector('swiper-slider')) {
                if (this.classList.contains('complementary-products')){
                  this.remove();
                }
              }
    
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
                this.classList.remove('tw-hidden');
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };
    
        
}
    

customElements.define('cart-product-recommendations', CartProductRecommendations);